
// import loader from '../../assets/img/loader.svg';
const Loader = () => {
    return (
        <div id="global-loader" className='center'>
            {/* <img src={loader} className="loader-img" alt="Loader"/> */}
            <div className="spinner-border text-warning" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );
};

export default Loader;
